if (!customElements.get('product-bar')) {
  class ProductBar extends HTMLElement {
    constructor() {
      super();

      this.closed = getCookie('product-bar-closed');

      this.closeButton = this.querySelector('[data-close]');

      this.debouncedScroll = debounce(
        () => this.toggleVisibility(),
        300
      );
      this.changeEvent = new Event('change', { bubbles: true });
    }

    get selectedOptionValues() {
      return Array.from(
        this.querySelectorAll('input[type="radio"]:checked, select'),
        el => ({
          name: el.dataset.name,
          value: el.value,
          id:
            el.dataset.optionValueId ||
            el.selectedOptions[0]?.dataset.optionValueId ||
            ''
        })
      );
    }

    setHandlers() {
      window.addEventListener(
        'scroll',
        this.debouncedScroll.bind(this)
      );
      window.addEventListener(
        'resize',
        this.debouncedScroll.bind(this)
      );
      this.addEventListener('change', event => {
        if (event.target.type === 'number') {
          const quantity = document.querySelector(
            'main-product [name="quantity"]'
          );

          if (!quantity) return;

          quantity.value = event.target.value;
          quantity.dispatchEvent(this.changeEvent);

          return;
        }

        document
          .querySelector('product-selector')
          .onVariantChange(event, this.selectedOptionValues);
      });
      this.closeButton.addEventListener('click', () => {
        const isClosed = this.classList.contains('is-closed');
        isClosed
          ? setCookie('product-bar-closed', '')
          : setCookie('product-bar-closed', 'true');
        this.classList.toggle('is-closed');
      });
    }

    toggleVisibility() {
      const formActions = document.querySelector(
        '[data-product-actions]'
      );
      const shouldShowBar =
        formActions.getBoundingClientRect().top <= 0;

      this.classList.toggle('is-hidden', !shouldShowBar);
    }

    connectedCallback() {
      this.closed && this.classList.add('is-closed');
      this.setHandlers();
      this.toggleVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.debouncedScroll);
      window.removeEventListener('resize', this.debouncedScroll);
    }
  }

  customElements.define('product-bar', ProductBar);
}
